module.exports = __webpack_public_path__ + "b50d9fae898b29286b140df8b46b2c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/profileOnboarding.png
// module id = 2821
// module chunks = 1